import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { useIntl } from 'react-intl'
import { useDayJsLocale } from './useDayJsLocale'

dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)

/**
 * @description Given a date and its template, returns a formatted date based on a template.
 * @param {Date | string} date - Date to format.
 * @param {string} inputTemplate - Date input template.
 * @param {string} outputTemplate - Date output template.
 * @param {string} forcedLocale - Forced locale to use. If not passed, the locale will be taken from the `intl` context.
 * @returns {string} Formatted date.
 * @example
 * const formattedDate = useDateFormatter('2020-01-01')
 * const formattedDate = useDateFormatter('2020-01-01', 'YYYY-MM-DD')
 * const formattedDate = useDateFormatter('2020-01-01', 'YYYY-MM-DD', 'DD/MM/YYYY')
 * const formattedDate = useDateFormatter('2020-01-01', 'YYYY-MM-DD', 'DD/MM/YYYY', 'en-US')
 */
export const useDateFormatter = (date, inputTemplate = 'YYYY-MM-DD', outputTemplate = 'L', forcedLocale = null) => {
	const { locale: localeContext } = useIntl()
	const locale = useDayJsLocale(forcedLocale || localeContext)
	// .replace(' ', 'T') iOS fix error
	try {
		return date
			? dayjs(date?.replace ? date.replace(' ', 'T') : date, inputTemplate, locale).format(outputTemplate)
			: ''
	} catch (e) {
		console.error(e)
		return ''
	}
}
